export const formatLocaleForGraphQL = (locale?: string) => {
  return locale ? locale.toUpperCase().replace("-", "_") : "EN";
};
